import { render } from "./RefineModel.vue?vue&type=template&id=c0d01eac&scoped=true&ts=true"
import script from "./RefineModel.vue?vue&type=script&lang=ts"
export * from "./RefineModel.vue?vue&type=script&lang=ts"

import "./RefineModel.vue?vue&type=style&index=0&id=c0d01eac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0d01eac"]])

export default __exports__